import React from 'react';
import { TableContainer, Table } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import useStyling from '../../../hooks/useStyling';
import { localise } from '../../../services/lang/lang';
import ResultTableBody from '../ResultTableBody/ResultTableBody';
import SortableTableHead from '../SortableTableHead/SortableTableHead';
import InspectionsTableRow from './InspectionsTableRow';
import Pagination from '../Pagination/Pagination';
import InspectionsTableActionMenu from './InspectionsTableActionMenu';
export const INSPECTION_LIST_TABLE_HEADERS = [
    {
        key: 'address',
        title: localise('ADDRESS'),
        isDisabledInColumnMenu: true,
        sortField: 'address',
        selectedByDefault: true,
    },
    {
        key: 'uprn',
        sortField: 'property.uprn',
        title: localise('UPRN'),
    },
    {
        key: 'reference',
        sortField: 'reference',
        title: localise('REFERENCE'),
    },
    {
        key: 'inspection_date',
        sortField: 'inspection_date',
        title: localise('INSPECTION_DATE'),
    },
    {
        key: 'inspector',
        title: localise('INSPECTOR'),
        sortField: 'creator.full_name',
        showOnlyForScope: 'team-inspections',
    },
    {
        key: 'hazards',
        sortField: 'hazard_count',
        title: localise('HAZARDS'),
    },
    {
        key: 'cat1',
        sortField: 'hazard_cat1_count',
        title: localise('CAT_1'),
    },
    {
        key: 'cat2',
        sortField: 'hazard_cat2_count',
        title: localise('CAT_2'),
    },
    {
        key: 'scored',
        title: localise('SCORED'),
    },
    {
        key: 'actions',
        title: localise('ACTIONS'),
    },
    {
        key: 'last_updated',
        sortField: 'updated_at',
        title: localise('LAST_UPDATED'),
    },
];
const InspectionsTable = ({ isFetching, inspections, scope, currentSortOptions, onSort, pagination, selectedColumns, onInspectionMutated, }) => {
    const history = useHistory();
    const styling = useStyling();
    const filteredHeaders = INSPECTION_LIST_TABLE_HEADERS.filter((header) => {
        if ('showOnlyForScope' in header && header.showOnlyForScope !== scope) {
            return false;
        }
        if (selectedColumns && !selectedColumns.includes(header.key)) {
            return false;
        }
        return true;
    });
    const onRowClicked = (inspection) => {
        history.push(`/inspections/${inspection.id}`);
    };
    const extraColumns = 1;
    return (React.createElement(TableContainer, { sx: styling.tableContainer.roundedWithPadding },
        React.createElement(Table, { cursor: "default", variant: "rounded" },
            React.createElement(SortableTableHead, { currentSortOptions: currentSortOptions, onSort: onSort, headers: filteredHeaders, leftPadding: extraColumns }),
            React.createElement(ResultTableBody, { isFetching: isFetching, colCount: filteredHeaders.length + extraColumns, sx: styling.tableBody.noHover }, inspections?.map((inspection) => (React.createElement(InspectionsTableRow, { onRowClicked: onRowClicked, scope: scope, key: inspection.id, inspection: inspection, selectedColumns: selectedColumns, childCellWidth: "56px" },
                React.createElement(InspectionsTableActionMenu, { inspection: inspection, onInspectionMutated: onInspectionMutated })))))),
        pagination && React.createElement(Pagination, { meta: pagination, isFetching: isFetching })));
};
export default InspectionsTable;
